import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-expand",
  templateUrl: "./med-icon-expand.component.html",
})
export class MedIconExpandComponent extends SvgMixinComponent {}
